import './Navbar.css'

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.muware.echonote';

// Navbar de la landing — plus aucun lien vers l'app web (login/signup retirés).
// Le seul CTA mène vers l'app mobile.
const Navbar = () => {

    return (

        <div className="navbar">
            <div className="navbar-container">
                <div className="navbar-logo">
                    <img src="/logo_dark.png" alt="EchoNote Logo" />
                </div>

                <div className="navbar-links">
                    <a href="/#features">Features</a>
                    <a href="/#how-it-works">How it works</a>
                    <a href="/#faq">FAQ</a>
                </div>

                <div className="navbar-buttons">
                    <a className="button-plain no-style-link" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                        <span className="material-symbols-outlined icon">smartphone</span>
                        Get the app
                    </a>
                </div>
            </div>
        </div>
    )

}

export default Navbar;
